import { TableColumn } from "./table-column";

/**
 * Class to encapsulate functions needed to work with a data table dashboard
 **/
export class DataTableDashboard {
  allColumns: TableColumn[];

  constructor(tableColumnsJson: Array<any>) {
    const dashboardCheck: {
      [key: string]: number
    } = {};

    this.allColumns = [];

    tableColumnsJson.map((c, idx) => {
      // This check is to make sure we don't duplicate identifiers as they are used for storing preferences
      dashboardCheck[c.identifier] = (dashboardCheck[c.identifier] || 0) + 1;
      if (dashboardCheck[c.identifier] > 1) alert(`${c.identifier} is duplicated!!`);
      this.allColumns.push(new TableColumn({ ...c, position: idx }));
    });
  }

  get visibleColumns() {
    return this.allColumns.filter((c: TableColumn) => {
      return c.isVisible;
    });
  }
}